import { SxProps } from '@mui/material';
import { lightTheme } from '../../theme/index';

const { palette, spacing } = lightTheme;

const styles: Record<string, SxProps> = {
  common: {
    position: 'fixed',
    bottom: spacing(2),
    right: spacing(2),
    zIndex: 3
  },
  primary: {
    backgroundColor: palette.grey[50],
    '&:hover': {
      backgroundColor: palette.primary.main,
      svg: {
        color: palette.grey[100]
      }
    }
  }
};

export default styles;
